import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { User } from '../models/user';
import { Horse_show } from '../models/horse_show';
import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private user: Subject<User> = new BehaviorSubject<User>(new User({}));

  private horse_show:Subject<Horse_show> = new BehaviorSubject<Horse_show>(new Horse_show({name: "Current horse show not set..."}));
  private working_date: Subject<Date> = new BehaviorSubject<Date>(new Date());

  user$ = this.user.asObservable();
  horse_show$ = this.horse_show.asObservable();
  working_date$ = this.working_date.asObservable();

  constructor() {
   }


  setUser(user: User){

    this.user.next(user);
  }

  setHorse_show(horse_show: Horse_show){
  	this.horse_show.next(horse_show);
  }

  setWorkingDate(date: Date){
    this.working_date.next(date);
  }

}
